// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5638":"0bea5ca4","5724":"d95f6ac7"}[chunkId] + ".css";
};